function Modal(props){
    return <div className='absolute h-full w-full overflow-x-hidden'>
                <div className='relative flex flex-col h-full bg-neutral-300/50 z-10'>
                    <div className='relative grid grid-rows-5 grid-flow-col text-center bg-white rounded-lg h-7/8 w-7/8 md:h-2/3 md:w-3/5 m-auto border-black border-b-2 border-r-2'>
                        <button onClick={() => props.setShowModal(false)} className='absolute right-0 top-0 pr-3 pt-3'> X </button>
                        <div className='grid row-span-1 content-center font-bold'> {props.modalData.title}</div>
                        <div className='grid row-span-3 content-center'> {props.modalData.content}</div>
                        <div className='grid row-span-1 content-center'> {props.modalData.action}</div>
                    </div>
                </div>
            </div>
}

export {Modal}